// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-D":"D_load-shedding-D__6r_Td"};